import { sessionUrl } from '@/appConfig/appConfig.js'
import axios from 'axios'

const eventActions = [
  'clicked_header_logo',
  'clicked_header_logout',
  'clicked_drawer_open',
  'clicked_drawer_close',
  'clicked_drawer_wizard_button',
  'clicked_drawer_compare_button',
  'clicked_drawer_lookup_button',
  'clicked_drawer_logout',
  'login_via_link',
  'submit_initial_form',
  'clicked_back_link',
  'clicked_start_screen_wizard_button',
  'clicked_start_screen_compare_button',
  'clicked_start_screen_lookup_button',
  'changed_wizard_field',
  'clicked_wizard_summary_go_back_link',
  'clicked_wizard_summary_go_back_button',
  'clicked_wizard_summary_see_results_link',
  'clicked_wizard_summary_see_results_button',
  'clicked_wizard_summary_harmonyconnections@coloniallife.com_link',
  'clicked_wizard_summary_uwcaresteamcol@unum.com_link',
  'clicked_compare_add_platform_button',
  'toggle_compare_platform_section',
  'submit_lookup_search',
  'clicked_lookup_no_results_button',
  'clicked_lookup_remove_platform_button',
  'toggle_lookup_compare_this_button',
  'clicked_lookup_final_selection_button',
  'clicked_compare_drawer_open_button',
  'clicked_compare_drawer_remove_platform_button',
  'clicked_compare_drawer_details_button',
  'submit_add_platform_drawer_search',
  'made_final_selection',
  'clicked_final_selection_start_over_button',
  'toggle_final_selection_platform_section',
  'clicked_unknown_platform_wizard_button',
  'clicked_product_hosted_wizard_button'
]

console.log(eventActions)

/**
 * sessionEvent()
 *
 * @param {string} sessionKey (from JWT/Firebase)
 * @param {string} actionString
 * @param {object} data (ex: { action: 'login_via_link' })
 * @param {object} customProps
 * @returns Promise (then-able)
 */
function sessionEvent (sessionKey, actionString, data, customProps) {
  // example url path:
  // https://FIREBASE_APP.firebaseio.com/sessions/-L9CGpx2ASGM-165s9K8/timeline/123456789/.json
  let sessionPathArray = [
    sessionUrl,
    'sessions',
    sessionKey,
    'timeline',
    Date.now(),
    '.json'
  ]
  const sessionPath = sessionPathArray.join('/')

  return new Promise(function (resolve, reject) {
    axios({
      method: 'patch',
      url: sessionPath,
      data: {
        action: actionString,
        data: {
          ...data
        },
        ...customProps
      }
    })
      .then(function (res) {
        resolve(res)
      })
      .catch(function (err) {
        reject(err)
      })
  })
}

export default sessionEvent



// WEBPACK FOOTER //
// ./src/util/sessionEvent.js